import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { RiesgoService } from 'app/services/riesgo/riesgo.service';
import Swal from 'sweetalert2';
import { FormControl, FormGroup } from '@angular/forms';
import { LoginService } from 'app/services/login/login.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-listado-excepciones',
  templateUrl: './listado-excepciones.component.html',
  styleUrls: ['./listado-excepciones.component.scss']
})
export class ListadoExcepcionesComponent implements OnInit {

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_id_soles=environment.ID_GUIA_SOLES;
  loading: boolean = false;
  pageSizeOptions = [15, 20, 30, 50, 100, 200];
  displayedColumns = ['checked', 'RUC', 'Razon_Social','Sector_Adquirente', 'Tipo', 'Ubicacion', 'Scoring_Puntaje','RUC_relacionada','RazSocial_relacionada','top_relacionada','Sector_Relacionada','Comentario'];
  dataSource: any;
  user: any;
  empresas: any = [];
  abrirContactos: boolean = false;
  abrirDetalleReclamo: boolean = false;
  abrirPopUp: boolean = false;
  estado: any;

  form: FormGroup;
  dataEnviar: any = {};  
  sectores:any;
  rucEmpFilter = new FormControl('');
  razEmpFilter = new FormControl('');
  filterValues ={
    razonSocial:'',
    ruc:'',
    Sector:'',
    TipoL:''
  }
  dataFiltro :FormGroup;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(private riesgosService: RiesgoService, private loginService:LoginService, private router:Router) {
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.dataFiltro = new FormGroup({
      "Sector":new FormControl(''),
      "TipoL":new FormControl('')
    });
    
    this.riesgosService.dataExcepciones = 0;
 }

  ngOnInit() {

    this.listadoExcepciones();
    this.ListarSectores();    
    this.razEmpFilter.valueChanges.subscribe(
        razonSocial=>{
          this.filterValues.razonSocial=razonSocial;
          this.dataSource.filter=JSON.stringify(this.filterValues);
        }
    )

    this.rucEmpFilter.valueChanges.subscribe(
      ruc=>{
        this.filterValues.ruc=ruc;
        this.dataSource.filter=JSON.stringify(this.filterValues);
      }
  )

  this.dataFiltro.get('Sector').valueChanges.subscribe(
    Sector => {
      this.filterValues.Sector = Sector;
      this.dataSource.filter = JSON.stringify(this.filterValues);
    }
  );

  this.dataFiltro.get('TipoL').valueChanges.subscribe(
    TipoL => {
      this.filterValues.TipoL = TipoL;
      this.dataSource.filter = JSON.stringify(this.filterValues);
    }
  );
  }

  createFilter(): (data: any, filter: string) => boolean {
    return function(data, filter): boolean {
      let searchTerms = JSON.parse(filter);
      return  data.Razon_Social.toString().toLowerCase().indexOf(searchTerms.razonSocial) !== -1
      && data.Num_Doc_Identificacion.toString().toUpperCase().indexOf(searchTerms.ruc) !== -1
      && data.idSector_Adquirente === (searchTerms.Sector== ''?data.idSector_Adquirente:searchTerms.Sector) 
      && data.Estado_ID.toString().toUpperCase().indexOf(searchTerms.TipoL) !== -1
    }
  }

  listadoExcepciones() {
    this.loading = true;
    this.riesgosService.ListadoExcepciones().subscribe(
      res => {
        this.empresas = res;
        this.empresas = this.empresas.filter(emp => emp.Estado_ID == 1);
        this.dataSource = new MatTableDataSource(this.empresas);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.dataSource.filterPredicate = this.createFilter();
        this.loading = false;
      }, err => {
        Swal.fire({
          title: "!Algo salió mal!",
          text: err.error['error'],
          type: "warning",
          allowOutsideClick: false,
          heightAuto: false
        });
        // this.loading = false
      }
    )
  }
  
  open(element:any){
   console.log(element);
  }

  update(id: any, tipo: any, event:any) {
    if (event == null) { return; }
    this.cambiarEstado(id, tipo,event)    
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  cambiarEstado(id: any, tipo: any,event:any) {
    this.loading = true;
    if (tipo == "USD") {
      tipo = 1;
    } else {
      tipo = this.Label_id_soles;
    }
          this.dataEnviar.id = id;
          this.dataEnviar.Tipo = tipo;
          this.dataEnviar.Estado = 0;
          this.dataEnviar.Usuario = this.user.Usuario;
          this.dataEnviar.Razon = event;
          this.riesgosService.EditarExcepcion(this.dataEnviar)
            .subscribe(res => {
              this.loading = false;
              Swal.fire({
                title: "Se envio a la lista Negra",
                type: "success",
                allowOutsideClick: false,
                heightAuto: false
              })
              .then(resp => {
                if (resp.value == true) {
                  this.listadoExcepciones();
                }
              });
            }, (err: HttpErrorResponse) => {
              this.loading = false;   
              Swal.fire({
                title: "Ha ocurrido un error",
                text: err.error.id,
                type: "error",
                allowOutsideClick: false,
                heightAuto: false
              })       
            })      
  }

  cambiarTipoEx(estado: any, id: any, tipo: any) {
    this.loading = true;
    if (estado == "ACTIVO") {
      estado = 1;
    } else if (estado == "DESACTIVADO") {
      estado = 0;
    }
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-i-success',
        cancelButton: 'btn btn-danger'
      },
      buttonsStyling: false
    })
    swalWithBootstrapButtons.fire({
      title: '¿Estás seguro de cambiar el tipo de moneda ' + tipo + '?',
      text: '',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si',
      cancelButtonText: 'No',
      reverseButtons: true,
      heightAuto: false,
      allowOutsideClick: false
    })
      .then((result) => {
        this.loading = true;
        if (result.value) {

          if (tipo == "USD") {
            tipo = this.Label_id_soles;
          } else {
            tipo = 1;
          }
           this.dataEnviar.id = id;
          this.dataEnviar.Tipo = tipo;
          this.dataEnviar.Estado = estado;
          this.dataEnviar.Usuario = this.user.Usuario;
          this.riesgosService.EditarExcepcion(this.dataEnviar)
            .subscribe(res => {
              this.loading = false;
              swalWithBootstrapButtons.fire({
                title: 'Actualizado!',
                text: 'La moneda fue cambiada satisfactoriamente',
                type: 'success',
                heightAuto: false,
                allowOutsideClick: false
              }).then(resp1 => {
                if (resp1.value == true) {
                  this.listadoExcepciones();
                }
              });
            }, (err: HttpErrorResponse) => {
              this.loading = false;
            })
        }
        else if (
          result.dismiss === Swal.DismissReason.cancel
        ) this.loading = false;
      }
      )
  }

  ListarSectores(){
    this.riesgosService.obtenerSectoresEconomicos().subscribe(
      res=>{
        this.sectores=res;
          this.sectores=this.sectores.filter(est => est.Estado == "A");
      }, err => {
        Swal.fire({
          title: err.error['error'],
          type: "warning",
          allowOutsideClick: false,
          heightAuto: false
        });
        // this.loading = false
      } 
    )      
  }

  verDocumento(element){
      this.loginService.clickGuard = true;
      this.riesgosService.dataExcepciones = element
      this.router.navigate(['/riesgo/empresa/nuevo']);    
  }

}
